import {
  ButtonComponent,
  ButtonSubTheme,
  ButtonTheme,
  ButtonType,
} from '@myre/ui-primitive-components';
import { TranslatePipe } from '@myre/ui-primitive-core';

import { AsyncPipe } from '@angular/common';
import { Component, inject, type OnInit } from '@angular/core';
import { type Observable } from 'rxjs';

import {
  type IModalComponent,
  type IModalContext,
  type IModalFooter,
} from '../../../modal.interface';
import { ModalService } from '../../../modal.service';

@Component({
  selector: 'myre-modal-footer-default',
  templateUrl: './app-modal-footer-default.component.html',
  styleUrls: ['./app-modal-footer-default.component.scss'],
  imports: [ButtonComponent, TranslatePipe, AsyncPipe],
})
export class DefaultFooterComponent implements IModalComponent, OnInit {
  private _modalService = inject(ModalService);

  public isLoading$: Observable<boolean>;
  public uid: string;
  public context: IModalContext;
  public data: IModalFooter;

  public ngOnInit(): void {
    const modalData = this._modalService.getModal(this.uid);

    if (modalData) {
      this.context = modalData.context;
      this.data = modalData.footer ? modalData.footer.data : {};
    }
  }

  public okDisabled(): boolean {
    if (this.context && this.context.formGroup) {
      // if form has control(s) it should have at least one element dirty & valid
      return (
        Object.keys(this.context.formGroup.controls).length &&
        !(
          this.context.formGroup &&
          this.context.formGroup.valid &&
          this.context.formGroup.dirty
        )
      );
    }

    return false;
  }

  public click(action: string): void {
    if ('function' === typeof (this.context as any)[`${action}Click`]) {
      return (this.context as any)[`${action}Click`].call();
    }
  }

  protected readonly ButtonTheme = ButtonTheme;
  protected readonly ButtonSubTheme = ButtonSubTheme;
  protected readonly ButtonType = ButtonType;
}
